import { el } from "@dhx/ts-common/dom";
import { locateNode } from "@dhx/ts-common/html";
import { ScrollView } from "@dhx/ts-common/ScrollView";
import { Sidebar } from "./Sidebar";
import { IProSidebar } from "./types";
import { tooltip, Position } from "@dhx/ts-message";

export class ProSidebar extends Sidebar implements IProSidebar {
	scrollView: ScrollView;

	constructor(element?: string | HTMLElement, config?) {
		super(element, config);
		this.scrollView = new ScrollView(() => this.getRootView());
	}

	protected _draw() {
		const { width, minWidth } = this.config;
		const actualWidth = this.config.collapsed ? minWidth : width;

		const navBar = [
			el(
				"ul.dhx_navbar.dhx_navbar--vertical",
				{
					"data-dhx-widget-id": this._uid,
					tabindex: 0,
					onclick: this._handlers.onclick,
					onmousedown: this._handlers.onmousedown,
					oninput: this._handlers.input,
					onmouseover: this._handlers.tooltip,
					_hooks: {
						didInsert: node => {
							node.el.addEventListener(
								"keyup",
								e => {
									if (e.which !== 9) {
										return;
									}
									const elem = locateNode(document.activeElement);
									if (!elem) {
										return;
									}

									const id = elem.getAttribute("data-dhx-id");
									const item = this.data.getItem(id);
									if (item.tooltip || (this.config.collapsed && item.value)) {
										tooltip(item.tooltip || item.value, {
											node: elem as HTMLElement,
											position: Position.right,
											force: true,
										});
									}
								},
								true
							);
						},
					},
				},
				this.data.map(item => this._factory(item), this.data.getRoot(), false)
			),
		];

		return el(
			"nav.dhx_widget.dhx_sidebar",
			{
				class:
					(this.config.css ? this.config.css : "") +
					(this.config.collapsed ? " dhx_sidebar--minimized" : ""),
				style: { width: actualWidth + "px" },
			},
			this.scrollView && this.scrollView.config.enable
				? [].concat(this.scrollView.render(navBar))
				: navBar
		);
	}
}
